module.exports = __webpack_public_path__ + "img/avi.9adf8004.svg";